import React from 'react';
import { BookOpen, Award, CheckCircle, XCircle } from 'lucide-react';

const GradesTable = ({ details, moyenneSemestre }) => {
  const getMentionLabel = (noteSur20) => {
    if (noteSur20 >= 18) return 'Excellent';
    if (noteSur20 >= 16) return 'Très Bien';
    if (noteSur20 >= 14) return 'Bien';
    if (noteSur20 >= 12) return 'Assez Bien';
    if (noteSur20 >= 10) return 'Passable';
    return 'Insuffisant';
  };

  const totalCoefficients = details?.reduce((sum, detail) => {
    const coefficient = detail.moyenne_module?.module_classe?.coeficient || 1;
    return sum + coefficient;
  }, 0) || 0;

  const totalPoints = details?.reduce((sum, detail) => {
    const noteCoef = detail.moyenne_module?.moyenne_finale || 0;
    return sum + noteCoef;
  }, 0) || 0;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center">
          <span className="w-2 h-2 bg-[#202654] rounded-full mr-3"></span>
          Détail des Notes par Module
        </h3>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-[#202654] text-white">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-medium">
                Module
              </th>
              <th className="px-4 py-3 text-center text-sm font-medium">
                Moy./20
              </th>
              <th className="px-4 py-3 text-center text-sm font-medium">
                Coef.
              </th>
              <th className="px-4 py-3 text-center text-sm font-medium">
                Note × Coef.
              </th>
              <th className="px-4 py-3 text-center text-sm font-medium">
                Rang
              </th>
              <th className="px-4 py-3 text-center text-sm font-medium">
                Mention
              </th>
              <th className="px-4 py-3 text-center text-sm font-medium">
                Validé
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {details && details.length > 0 ? (
              details.map((detail, index) => {
                const moyenne = detail.moyenne_module;
                const module = moyenne?.module_classe?.module;
                const coefficient = moyenne?.module_classe?.coeficient || 1;
                const noteBase = moyenne?.moyenne_finale ? (moyenne.moyenne_finale / coefficient) : 0;
                const noteCoef = moyenne?.moyenne_finale || 0;
                const rang = moyenne?.rang_module ? `${moyenne.rang_module}e` : 'N/A';
                const mention = getMentionLabel(noteBase);
                
                return (
                  <tr key={detail.id || index} className="hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <div className="font-medium text-gray-900">
                        {module?.libelle || 'Module inconnu'}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800">
                        {noteBase.toFixed(2)}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                        {coefficient}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className="font-semibold text-gray-900">
                        {noteCoef.toFixed(2)}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#202654] text-white text-sm font-medium">
                        {rang}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium ${
                        mention === 'Excellent' ? 'bg-green-100 text-green-800' :
                        mention === 'Très Bien' ? 'bg-blue-100 text-blue-800' :
                        mention === 'Bien' ? 'bg-yellow-100 text-yellow-800' :
                        mention === 'Assez Bien' ? 'bg-orange-100 text-orange-800' :
                        mention === 'Passable' ? 'bg-red-100 text-red-800' :
                        'bg-gray-100 text-gray-800'
                      }`}>
                        {mention}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center">
                      {moyenne?.est_valide ? (
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-green-100 text-green-600">
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        </span>
                      ) : (
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-red-100 text-red-600">
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                          </svg>
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" className="px-4 py-8 text-center text-gray-500">
                  <div className="flex flex-col items-center">
                    <svg className="w-12 h-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <p className="text-lg font-medium">Aucun module disponible</p>
                    <p className="text-sm">Aucune note n'a été enregistrée pour ce semestre.</p>
                  </div>
                </td>
              </tr>
            )}
            
            {/* Ligne de total */}
            {details && details.length > 0 && (
              <tr className="bg-[#202654] text-white">
                <td className="px-4 py-3 font-semibold">
                  TOTAL
                </td>
                <td className="px-4 py-3 text-center">
                  -
                </td>
                <td className="px-4 py-3 text-center font-semibold text-lg">
                  {totalCoefficients}
                </td>
                <td className="px-4 py-3 text-center font-semibold text-lg">
                  {totalPoints.toFixed(2)}
                </td>
                <td className="px-4 py-3 text-center">
                  -
                </td>
                <td className="px-4 py-3 text-center">
                  -
                </td>
                <td className="px-4 py-3 text-center">
                  -
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GradesTable;
